<template>
  <div class="main">
    <div class="dropfile">
      <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
        <input type="file" multiple name="file" id="fileInput" class="hidden-input" @change="onChange" ref="file"/>
        <label class="file-label" v-show="!uploading && uploadComplete && files.length == 0">DICOM enviado com sucesso!</label>
        <label for="fileInput" class="file-label" v-show="files.length == 0">
          <div v-if="isDragging">Arraste os arquivos aqui.</div>
          <div v-else>Arraste os arquivos <u @select="drop(e)">aqui</u> para upload.</div>
        </label>
        <div class="preview-container" v-if="files.length">
          <div v-for="file in files" :key="file.name" class="preview-card">
            <div class="file-info">
              <img class="preview-img" :src="generateURL(file)" />
              <p>
                {{ file.name }}
                {{ Math.round(file.size / 1000) + "kb" }}
              </p>
            </div>
            <p>{{ file.status }}</p>
            <button class="remove-btn" v-show="!uploading" type="button" @click="remove(files.indexOf(file))" title="Remove file">
              <b>×</b>
            </button>
          </div>
        </div>
      </div>
      <div>
        <v-btn @click="uploadAllImages" v-show="!uploading && files.length > 0">Enviar Imagens</v-btn>
        <div v-show="uploading && imageUploading != null"><h3>Enviando imagen: {{ imageUploading }}...</h3></div>
      </div>
    </div>
  </div>

</template>

<script>
import { uploadImage } from '@/store/firebase'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      isDragging: false,
      isSuported: true,
      uploadComplete: false,
      uploading: false,
      imageUploading: null,
      files: []
    }
  },
  computed: {
    ...mapState({
      company: state => state.company
    })
  },
  methods: {
    onChange () {
      this.files.push(...this.$refs.file.files)
    },
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave () {
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      this.$refs.file.files = e.dataTransfer.files
      // for (const files of this.$refs.file.files) if (!files.name.endsWith('.dcm')) this.isSuported = false
      if (this.isSuported) this.onChange()
      else this.isSuported = true
      this.isDragging = false
    },
    remove (i) {
      this.files.splice(i, 1)
    },
    generateURL (file) {
      let fileSrc = URL.createObjectURL(file)
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc)
      }, 1000)
      return fileSrc
    },
    async uploadAllImages () {
      this.uploading = true
      this.uploadComplete = false
      const uploadedUrls = []
      for (const file of this.files) {
        this.imageUploading = file.name
        const url = await uploadImage(file, file.name, this.company)
        file.status = url ? 'Sucesso' : 'Erro no envio'
      }
      if (uploadedUrls) {
        this.files = []
        this.uploadComplete = true
        console.log('uploadedUrls', uploadedUrls)
      } else this.uploadComplete = false
      this.uploading = false
    }
  }
}
</script>

<style>
.main {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dropfile {
  width: 100%;
}

.dropzone-container {
  width: 100%;
  height: 60vh;
  padding: 2rem;
  background: #f7fafc;
  border: 1px solid #aab3c0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 1.2rem;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.preview-card {
  display: flex;
  align-items: center;
  border: 1px solid #a2a2a2;
  padding: 0.5rem;
  margin: 0.5rem;
  width: 90%;
}

.file-info {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.preview-img {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
  margin-right: 0.5rem;
}

.remove-btn {
  margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/util/DropFile.vue